import { render, staticRenderFns } from "./TabFilters.vue?vue&type=template&id=0675b331"
import script from "./TabFilters.vue?vue&type=script&lang=js"
export * from "./TabFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports